import { render } from "./HomeLatestOnlyVideo.vue?vue&type=template&id=641a467e&scoped=true&ts=true"
import script from "./HomeLatestOnlyVideo.vue?vue&type=script&lang=ts"
export * from "./HomeLatestOnlyVideo.vue?vue&type=script&lang=ts"

import "./HomeLatestOnlyVideo.vue?vue&type=style&index=0&id=641a467e&scoped=true&lang=css"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641a467e"]])

export default __exports__